import axios from "axios";
import Header from "components/user/Header";
import Footer from "components/user/Footer";
import ListBerita from "components/user/berita/CardBerita";
import React, { useEffect, useRef, useState } from "react";
import { MdSearch } from "react-icons/md";
import { toast } from "react-toastify";

function Foto() {
  const [images, setImages] = useState([]);

  const [fullscreen, setFullscreen] = useState({
    open: false,
    src: "",
    caption: "",
  });

  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const sectionRef = useRef(null);

  // Loading ketika section masuk viewport
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setLoading(true);

          setTimeout(() => {
            setLoading(false);
          }, 800);

          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // Mengambil kategori berita
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`/api_w/postcategories`, {
          headers: {
            db_name: process.env.REACT_APP_DB_NAME,
          },
        });

        setCategories(response.data.data || []);
      } catch (error) {
        toast.error(error.response?.data?.message || error.message);
      }
    };

    fetchCategories();
  }, []);

  const handleCategoryFilter = (categoryId) => {
    setSelectedCategory(categoryId);
  };

  const SkeletonBox = ({ className }) => (
    <div className={`animate-pulse rounded bg-gray-200 ${className}`} />
  );

  // Wave Background
  const WaveBackground = ({ children }) => (
    <section className="relative min-h-[600px] overflow-hidden bg-[#0b5c2a]">
      {" "}
      <div className="absolute inset-0 bg-gradient-to-br from-[#1c9b4a] via-[#087236] to-[#063717]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_45%_35%,rgba(44,185,92,0.35),transparent_42%)]" />
      {children}
      <svg
        className="absolute bottom-0 left-0 h-[350px] w-full md:h-[350px]"
        viewBox="0 0 1440 220"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <path
          fill="#fff"
          d="M0,176 C210,204 415,168 636,140 C870,110 1025,112 1212,140 C1305,154 1375,164 1440,162 L1440,220 L0,220 Z"
        />
      </svg>
    </section>
  );

  // Skeleton Sidebar
  const SidebarSkeleton = () => (
    <div className="space-y-6">
      {/* Search Skeleton */}{" "}
      <div className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
        {" "}
        <SkeletonBox className="mb-4 h-5 w-24" />{" "}
        <SkeletonBox className="h-10 w-full rounded-xl" />{" "}
      </div>
      {/* Kategori Skeleton */}
      <div className="space-y-4 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
        <SkeletonBox className="h-5 w-28" />

        <div className="flex flex-wrap gap-2">
          {[1, 2, 3, 4].map((i) => (
            <SkeletonBox key={i} className="h-8 w-20 rounded-full" />
          ))}
        </div>
      </div>
      {/* Berita Skeleton */}
      <div className="space-y-4 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
        <SkeletonBox className="h-5 w-40" />

        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="flex gap-3 border-b border-gray-100 pb-4 last:border-0"
          >
            <SkeletonBox className="h-20 w-24 shrink-0 rounded-xl" />

            <div className="flex-1 space-y-2">
              <SkeletonBox className="h-4 w-full" />
              <SkeletonBox className="h-4 w-4/5" />
              <SkeletonBox className="h-3 w-1/2" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  // FUNCTION PENGAMBILAN DATA GALERI TETAP
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await axios.get(`/api_w/galleries?type=image`, {
          headers: {
            db_name: process.env.REACT_APP_DB_NAME,
          },
        });

        const formattedImages = response.data.data.map((image) => ({
          src: image.url,
          title: image.title,
        }));

        setImages(formattedImages);
      } catch (error) {
        toast.error(error.response?.data?.message || error.message);
      }
    };

    fetchImages();
  }, []);

  // Disable scroll ketika modal fullscreen terbuka
  useEffect(() => {
    if (fullscreen.open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [fullscreen.open]);

  return (
    <>
      {" "}
      <Header />
      {/* Banner Header */}
      <WaveBackground>
        <div className="relative z-10 mx-auto flex min-h-[600px] w-full max-w-7xl flex-col items-center justify-center px-5 pb-24 pt-28 text-center text-white md:pb-32 md:pt-24">
          <h1 className="max-w-8xl text-5xl font-bold leading-tight tracking-normal md:text-8xl">
            Galeri Foto DIAJENG
          </h1>

          <p className="mt-3 text-base font-normal text-white/90 md:text-2xl">
            Foto - Foto Dokumentasi tentang Digitalisasi Madrasah Jawa Tengah
          </p>
        </div>
      </WaveBackground>
      {/* Content */}
      <div
        ref={sectionRef}
        className="max-w-8xl mx-auto px-4 py-10 md:px-6 lg:px-8"
      >
        <div className="flex flex-col gap-8 lg:flex-row lg:items-start">
          {/* Galeri Foto */}
          <div className="w-full lg:w-[65%]">
            {loading ? (
              <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
                {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                  <SkeletonBox
                    key={i}
                    className="aspect-square w-full rounded-md"
                  />
                ))}
              </div>
            ) : (
              <>
                <h3 className="headers mt-[25px] text-2xl">
                  <span className="border-b-2 border-blue-600 font-bold hover:cursor-pointer hover:text-blue-700">
                    Galeri Foto
                  </span>
                </h3>

                <div className="mt-[15px] grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
                  {images.map((img, idx) => (
                    <div
                      key={idx}
                      className="group relative aspect-square w-full cursor-pointer overflow-hidden rounded-md bg-gray-100 shadow-sm"
                      onClick={() =>
                        setFullscreen({
                          open: true,
                          src: img.src,
                          caption: img.title,
                        })
                      }
                    >
                      <img
                        src={img.src}
                        alt={img.title || "foto"}
                        className="h-full w-full object-cover transition-transform duration-200 group-hover:scale-105"
                      />

                      {img.title && (
                        <div className="bg-black/60 absolute bottom-0 left-0 right-0 truncate px-1 py-1 text-center text-xs text-white">
                          {img.title}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>

          {/* Sidebar Berita */}
          <div className="w-full lg:w-[35%]">
            {loading ? (
              <SidebarSkeleton />
            ) : (
              <div className="space-y-6">
                {/* Search Box */}
                <div className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
                  <h3 className="mb-4 text-sm font-bold uppercase tracking-wide text-gray-800">
                    Cari Berita
                  </h3>

                  <div className="relative">
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder="Cari berita..."
                      className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 pr-12 text-sm text-gray-700 placeholder-gray-400 transition-all duration-200 focus:border-green-400 focus:outline-none focus:ring-2 focus:ring-green-500/30"
                    />

                    <button
                      type="button"
                      className="absolute right-1.5 top-1.5 rounded-lg bg-green-600 p-2 text-white transition-colors duration-200 hover:bg-green-700"
                    >
                      <MdSearch className="h-4 w-4" />
                    </button>
                  </div>
                </div>

                {/* Kategori Berita */}
                <div className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
                  <h3 className="mb-4 flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-gray-800">
                    <div className="h-5 w-1 rounded-full bg-green-500" />
                    Kategori Berita
                  </h3>

                  <div className="flex flex-wrap gap-2">
                    {/* Semua */}
                    <button
                      type="button"
                      onClick={() => handleCategoryFilter("")}
                      className={`inline-block cursor-pointer rounded-full px-3 py-1.5 text-xs font-medium transition-all duration-200 ${
                        selectedCategory === ""
                          ? "border border-green-600 bg-green-600 text-white"
                          : "border border-gray-200 bg-gray-50 text-gray-600 hover:border-green-300 hover:bg-green-50 hover:text-green-700"
                      }`}
                    >
                      Semua
                    </button>

                    {/* List Kategori */}
                    {categories.map((category) => (
                      <button
                        key={category.id}
                        type="button"
                        onClick={() =>
                          handleCategoryFilter(category.id.toString())
                        }
                        className={`inline-block cursor-pointer rounded-full px-3 py-1.5 text-xs font-medium transition-all duration-200 ${
                          selectedCategory === category.id.toString()
                            ? "border border-green-600 bg-green-600 text-white"
                            : "border border-gray-200 bg-gray-50 text-gray-600 hover:border-green-300 hover:bg-green-50 hover:text-green-700"
                        }`}
                      >
                        {category.name}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Berita Terbaru */}
                <div className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
                  <h3 className="mb-5 flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-gray-800">
                    <div className="h-5 w-1 rounded-full bg-green-500" />
                    Berita Terbaru
                  </h3>

                  <ListBerita
                    searchQuery={searchQuery}
                    selectedCategory={selectedCategory}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Fullscreen Modal */}
      {fullscreen.open && (
        <div
          className="bg-black/80 fixed inset-0 z-50 flex items-center justify-center"
          onClick={() =>
            setFullscreen({
              open: false,
              src: "",
              caption: "",
            })
          }
        >
          <img
            src={fullscreen.src}
            alt={fullscreen.caption || "foto"}
            className="max-h-[80vh] max-w-[90vw] rounded-md bg-white object-contain shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />

          {fullscreen.caption && (
            <div
              className="bg-black/70 absolute bottom-8 left-1/2 -translate-x-1/2 rounded px-4 py-2 text-center text-lg text-white"
              style={{
                maxWidth: "90vw",
                wordBreak: "break-word",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {fullscreen.caption}
            </div>
          )}

          <button
            className="bg-black/60 hover:bg-black/80 absolute right-10 top-6 z-10 flex h-10 w-10 items-center justify-center rounded-full text-3xl font-bold text-white"
            aria-label="Close"
            onClick={() =>
              setFullscreen({
                open: false,
                src: "",
                caption: "",
              })
            }
          >
            ×
          </button>
        </div>
      )}
      <Footer />
    </>
  );
}

export default Foto;
